var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar__container",style:(_vm.avatartStyle),on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.imgSrc)?_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.imgSrc}}):_c('span',{staticClass:"avatar-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }